import { MemberRegistration } from "../year-selection/member-registration.model";
import { AnnualRegistrationForm, DynamicQuestion, PaymentReceipt, ProceedInscriptionPaymentDto, RegistrationFormState, WorkHour } from "./inscription.model";
import { MemberSubscriptionFee } from "./member-subscriptionfeee.model";
import { ImageToAdd } from "./pdf-summary.model";

export class SelectYearForm {
  static readonly type = '[Inscription] SelectYearForm';
  constructor(public year: number) { }
}

export class InitInscriptionForm {
  static readonly type = '[Inscription] InitInscriptionForm';
  constructor() { }
}
export class InitInscriptionFormSuccess {
  static readonly type = '[Inscription] InitInscriptionFormSuccess';
  constructor(public data: any) { }
}
export class InitInscriptionFormFailure {
  static readonly type = '[Inscription] InitInscriptionFormFailure';
  constructor(public error: any) { }
}

export class LoadInscriptionForm {
  static readonly type = '[Inscription] LoadInscriptionForm';
  constructor() { }
}
export class LoadInscriptionFormSuccess {
  static readonly type = '[Inscription] LoadInscriptionFormSuccess';
  constructor(public data: any) { }
}
export class LoadInscriptionFormFailure {
  static readonly type = '[Inscription] LoadInscriptionFormFailure';
  constructor(public error: any) { }
}

export class SaveFormAnswers {
  static readonly type = '[Inscription] SaveFormAnswers';
  constructor(
    public formData: Pick<AnnualRegistrationForm, 'workHours' | 'answers' | 'workAddressesForUpdate'>,
  ) { }
}

export class SaveInscriptionForm {
  static readonly type = '[Inscription] SaveInscriptionForm';
  constructor(
    public inscription: AnnualRegistrationForm,
    public state: RegistrationFormState = RegistrationFormState.DRAFT,
    public redirectToPaymentReceipt: boolean = false
  ) { }
}

export class SubmitInscriptionForm {
  static readonly type = '[Inscription] SubmitInscriptionForm';
  constructor() { }
}
export class SubmitInscriptionFormSuccess {
  static readonly type = '[Inscription] SubmitInscriptionFormSuccess';
  constructor(public data: any) { }
}
export class SubmitInscriptionFormFailure {
  static readonly type = '[Inscription] SubmitInscriptionFormFailure';
  constructor(public error: any) { }
}

export class LoadInscriptionQuestions {
  static readonly type = '[Inscription] LoadInscriptionQuestions';
  constructor(public year?: number) { }
}
export class LoadInscriptionQuestionsSuccess {
  static readonly type = '[Inscription] LoadInscriptionQuestionsSuccess';
  constructor(public data: DynamicQuestion[]) { }
}
export class LoadInscriptionQuestionsFailure {
  static readonly type = '[Inscription] LoadInscriptionQuestionsFailure';
  constructor(public error: any) { }
}

export class LoadMemberEmail {
  static readonly type = '[Inscription] LoadMemberEmail';
}
export class LoadMemberEmailSuccess {
  static readonly type = '[Inscription] LoadMemberEmailSuccess';
  constructor(public email: string) { }
}
export class LoadMemberEmailFailure {
  static readonly type = '[Inscription] LoadMemberEmailFailure';
  constructor(public error: any) { }
}

export class ProceedInscriptionPayment {
  static readonly type = '[Inscription] ProceedInscriptionPayment';
  constructor(public dto: ProceedInscriptionPaymentDto) { }
}
export class ProceedInscriptionPaymentSuccess {
  static readonly type = '[Inscription] ProceedInscriptionPaymentSuccess';
  constructor(public data: PaymentReceipt) { }
}
export class ProceedInscriptionPaymentFailure {
  static readonly type = '[Inscription] ProceedInscriptionPaymentFailure';
  constructor(public error: any) { }
}

export class GeneratePDFImages {
  static readonly type = '[Inscription] GeneratePDFImages';
  constructor() { }
}
export class GeneratePDFImagesSuccess {
  static readonly type = '[Inscription] GeneratePDFImagesSuccess';
  constructor(public images: ImageToAdd[]) { }
}
export class GeneratePDFImagesFailure {
  static readonly type = '[Inscription] GeneratePDFImagesFailure';
  constructor(public error: any) { }
}

export class GeneratePDFReceiptImage {
  static readonly type = '[Inscription] GeneratePDFReceiptImage';
  constructor() { }
}
export class GeneratePDFReceiptImageSuccess {
  static readonly type = '[Inscription] GeneratePDFReceiptImageSuccess';
  constructor(public image: ImageToAdd) { }
}
export class GeneratePDFReceiptImageFailure {
  static readonly type = '[Inscription] GeneratePDFReceiptImageFailure';
  constructor(public error: any) { }
}

export class UploadPdf {
  static readonly type = '[Inscription] UploadPdf';
}
export class UploadPdfSuccess {
  constructor(public documentId: string) { }
  static readonly type = '[Inscription] UploadPdfSuccess';
}
export class UploadPdfFailure {
  static readonly type = '[Inscription] UploadPdfFailure';
  constructor(public error: any) { }
}

export class DownloadPdf {
  static readonly type = '[Inscription] DownloadPdf';
}

export class ProceedInscriptionChequePayment {
  static readonly type = '[Inscription] ProceedInscriptionChequePayment';
  constructor(public data: any) { }
}
export class ProceedInscriptionChequePaymentSuccess {
  static readonly type = '[Inscription] ProceedInscriptionChequePaymentSuccess';
  constructor(public data: any) { }
}

export class LoadMemberWorkHours {
  static readonly type = '[Inscription] LoadMemberWorkHours';
  constructor(public memberId: string) { }
}
export class LoadMemberWorkHoursSuccess {
  static readonly type = '[Inscription] LoadMemberWorkHoursSuccess';
  constructor(public workHours: WorkHour[]) { }
}
export class LoadMemberWorkHoursFailure {
  static readonly type = '[Inscription] LoadMemberWorkHoursFailure';
  constructor(public error: any) { }
}

export class LoadMemberSubscriptionFees {
  static readonly type = '[Inscription] LoadMemberSubscriptionFees';
  constructor(public memberId: string, public isResubscription: boolean, public donationAmount: number) { }
}
export class LoadMemberSubscriptionFeesSuccess {
  static readonly type = '[Inscription] LoadMemberSubscriptionFeesSuccess';
  constructor(public memberSubscriptionFees: MemberSubscriptionFee[]) { }
}
export class LoadMemberSubscriptionFeesFailure {
  static readonly type = '[Inscription] LoadMemberSubscriptionFeesFailure';
  constructor(public error: any) { }
}

export class LoadMemberRegistrations {
  static readonly type = '[Inscription] LoadMemberRegistrations';
  constructor(public memberId: string) { }
}
export class LoadMemberRegistrationsSuccess {
  static readonly type = '[Inscription] LoadMemberRegistrationsSuccess';
  constructor(public memberRegistrations: MemberRegistration[]) { }
}
export class LoadMemberRegistrationsFailure {
  static readonly type = '[Inscription] LoadMemberRegistrationsFailure';
  constructor(public error: any) { }
}

export class SetInscriptionAlreadyPayed {
  static readonly type = '[Inscription] SetInscriptionAlreadyPayed';
  constructor(public value: boolean) { }
}
